import React from 'react';
import ReactSelect from '../ReactSelect';

const roleOptions = [
  {
    value: 'ADMIN',
    label: 'Admin',
  },
  {
    value: 'USER',
    label: 'User',
  },
  {
    value: 'READONLY',
    label: 'Read Only',
  },
] as const;

export type UserRoleType = (typeof roleOptions)[number]['value'];

export const UserRolePicker = ({
  value,
  isClearable,
  onChange,
}: {
  value?: UserRoleType;
  isClearable?: boolean;
  onChange: (value?: UserRoleType) => void;
}) => (
  <ReactSelect
    placeholder="role"
    isClearable={isClearable}
    value={roleOptions.find((option) => value === option.value)}
    styles={{
      menu: (base) => ({
        ...base,
        minWidth: '120px',
      }),
    }}
    onChange={(value) => {
      onChange(value?.value ?? undefined);
    }}
    options={roleOptions}
  />
);
